import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

/**
 * Views are lazily imported so the initial bundle stays small; the trackers
 * pull in tables and filters that a first-time visitor to the dashboard does
 * not need.
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { title: 'Dashboard' },
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import('@/views/ClientsView.vue'),
    meta: { title: 'Clients' },
  },
  {
    path: '/clients/:id',
    name: 'client-detail',
    component: () => import('@/views/ClientDetailView.vue'),
    props: true,
    meta: { title: 'Client' },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/views/ProjectsView.vue'),
    meta: { title: 'Projects' },
  },
  {
    path: '/projects/:id',
    name: 'project-detail',
    component: () => import('@/views/ProjectDetailView.vue'),
    props: true,
    meta: { title: 'Project' },
  },
  {
    path: '/deliverables',
    name: 'deliverables',
    component: () => import('@/views/DeliverablesView.vue'),
    meta: { title: 'Delivery' },
  },
  {
    path: '/deliverables/:id',
    name: 'deliverable-detail',
    component: () => import('@/views/DeliverableDetailView.vue'),
    props: true,
    meta: { title: 'Deliverable' },
  },
  {
    path: '/languages',
    name: 'languages',
    component: () => import('@/views/LanguageVersionsView.vue'),
    meta: { title: 'Languages' },
  },
  {
    path: '/casting',
    name: 'casting',
    component: () => import('@/views/CastingView.vue'),
    meta: { title: 'Casting' },
  },
  {
    path: '/outstanding',
    name: 'outstanding',
    component: () => import('@/views/OutstandingView.vue'),
    meta: { title: 'Still needed' },
  },
  {
    path: '/intake/:batchId?',
    name: 'intake',
    component: () => import('@/views/IntakeView.vue'),
    props: true,
    meta: { title: 'Intake' },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { title: 'Vendors & markets' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: 'Not found' },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (_to, _from, saved) => saved ?? { top: 0 },
})

const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Bedouin'

router.afterEach((to) => {
  const title = to.meta.title as string | undefined
  document.title = title ? `${title} - ${APP_NAME}` : APP_NAME
})
